import React from "react";
import person1 from "../Images/person_1.jpg";
import person2 from "../Images/person_2.jpg";
import person3 from "../Images/person_3.jpg";
import person4 from "../Images/person_4.jpg";
import "../CSS/Team1.css";

const Team1=()=>{
    return(
        <section className="ftco-section Team1">
        <div className="container">
          <div className="row justify-content-center mb-5 pb-3">
            <div className="col-md-7 heading-section ftco-animate text-center">
              <h2 className="mb-4">Our Beauty Experts</h2>
              <p className="text-white">
              At Janushree Beauty Parlour, our team of skilled beauty experts is dedicated to enhancing your natural beauty with personalized services. 
              </p>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-3 d-flex mb-sm-4 ftco-animate " >
              <div className="staff teamdemo">
                <div
                  className="img mb-4"
                  // style={{ backgroundImage: `url(${person1})` }}
                />
                <div className="info text-center">
                  <h3>
                    <a href="">Priya</a>
                  </h3>
                  <span className="position">Stylist</span>
                  <div className="text">
                    <p style={{textAlign:"justify"}}>
                    An expert in skincare, Priya delivers personalized treatments for radiant, glowing skin.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-3 d-flex mb-sm-4 ftco-animate">
              <div className="staff teamdemo">
                <div
                  className="img mb-4"
                  // style={{ backgroundImage: `url(${person2})` }}
                />
                <div className="info text-center">
                  <h3>
                    <a href="">Nandhita</a>
                  </h3>
                  <span className="position">Fashionist</span>
                  <div className="text">
                    <p style={{textAlign:"justify"}}> 
                    Known for her exceptional hair styling skills, Nandhita creates stunning looks tailored to each client.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-3 d-flex mb-sm-4 ftco-animate">
              <div className="staff teamdemo">
                <div
                  className="img mb-4"
                  // style={{ backgroundImage: `url(${person3})` }}
                />
                <div className="info text-center">
                  <h3>
                    <a href="">Divya</a>
                  </h3>
                  <span className="position">Makeup Stylist</span>
                  <div className="text">
                    <p style={{textAlign:"justify"}}>
                    Divya is a talented makeup artist, specializing in transformative looks for every occasion.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-3 d-flex mb-sm-4 ftco-animate">
              <div className="staff teamdemo">
                <div
                  className="img mb-4"
                  // style={{ backgroundImage: `url(${person4})` }}
                />
                <div className="info text-center">
                  <h3>
                    <a href="">Kowsalya</a>
                  </h3>
                  <span className="position">Nail Specialist</span>
                  <div className="text">
                    <p style={{textAlign:"justify"}}>
                    Kowsalya offers a range of beauty services with a calming touch, ensuring a rejuvenating experience.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
}

export default Team1;